import { HvacResults, Uuid } from '@belimo-retrofit-portal/logic';
import { ReadonlyRecord } from 'fp-ts/ReadonlyRecord';
import React from 'react';
import { PdfMetadata } from 'src/modules/common/types/PdfMetadata';
import { Project } from 'src/modules/common/types/Project';
import { UserSettings } from 'src/modules/common/types/UserSettings';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';
import { ReportGenerated } from 'src/modules/report/types/ReportGenerated';
import { ReportDocumentPageAppendix } from 'src/modules/report/views/document/ReportDocumentPageAppendix';
import { ReportDocumentPageCover } from 'src/modules/report/views/document/ReportDocumentPageCover';
import { ReportDocumentPageEnergy } from 'src/modules/report/views/document/ReportDocumentPageEnergy';
import { ReportDocumentPageEvaluation } from 'src/modules/report/views/document/ReportDocumentPageEvaluation';
import { ReportDocumentPageHvac } from 'src/modules/report/views/document/ReportDocumentPageHvac';
import { ReportDocumentPageMethodology } from 'src/modules/report/views/document/ReportDocumentPageMethodology';
import { ReportDocumentPageSavings } from 'src/modules/report/views/document/ReportDocumentPageSavings';
import { Language } from 'src/types/common/Language';

type Props = {
  readonly language: Language;
  readonly document: ReportGenerated;
  readonly formData: ReportFormData;
  readonly project: Project;
  readonly userSettings: UserSettings;
  readonly embeddings: ReadonlyRecord<Uuid, PdfMetadata>;
  readonly results: HvacResults;
};

export const ReportDocumentContent = ({
  language,
  document,
  formData,
  project,
  userSettings,
  results,
  embeddings,
}: Props): React.ReactElement => (
  <>
    <ReportDocumentPageCover
      project={project}
      document={document}
      formData={formData}
      language={language}
      userSettings={userSettings}
    />

    <ReportDocumentPageSavings
      results={results}
      document={document}
      formData={formData}
      language={language}
    />
  </>
);
